import { useAffiliateSelector, useAffiliateDispatch } from '@/store/affiliate';
import { switchToCardFormStep, switchToPlansStep } from '@/store/affiliate/stepsSlice';

import { type Plan } from '@/utils/mapProductObject';
import { stripePromise, onExpressCheckoutConfirm } from '@/utils/stripe/affiliateOrderSubmitAdapter';

import PaymentMethodsScreenAdapterBase from '@/components/new-order/PaymentMethodsScreen/PaymentMethodsScreenAdapterBase';
import { isExtensionUser } from '@/utils/appLinks';
import AnalyticsEventHandler from '@/services/analytics/AnalyticsEventHandler';

const PaymentMethodsScreenAffiliateAdapter = () => {
  const { selectedPlanBlockData, isSubmitting } = useAffiliateSelector((state) => ({
    selectedPlanBlockData: {
      // should always be a selected plan here, sorry for assertion
      selectedPlan: state.plans.selectedPlan as Plan,
      couponDiscountPercentage: state.plans.selectedPlan?.savePercentage,
      isWebRoute: state.flags.isWebRoute,
    },
    isSubmitting: state.isSubmitting,
  }));

  const dispatch = useAffiliateDispatch();

  const onCardFormButtonClick = () => {
    dispatch(switchToCardFormStep());

    if (isExtensionUser()) {
      AnalyticsEventHandler.trackExtensionUserPayByCardClick(selectedPlanBlockData.selectedPlan.analyticsData.name);
    }
  };

  return (
    <PaymentMethodsScreenAdapterBase
      selectedPlanBlockData={selectedPlanBlockData}
      isSubmitting={isSubmitting}
      stripePromise={stripePromise}
      onExpressCheckoutConfirm={onExpressCheckoutConfirm}
      onBackButtonClick={() => dispatch(switchToPlansStep())}
      onCardFormButtonClick={onCardFormButtonClick}
    />
  );
};

export default PaymentMethodsScreenAffiliateAdapter;
